module.exports = __webpack_public_path__ + "static/img/0017.34053a6f.png";